<template>
  <div v-if="carteiras && carteiras.length">
    <v-card outlined class="app-card" v-if="aluno">
      <v-card-title class="app-card-title">Dados do Aluno</v-card-title>
      <v-card-text class="app-card-content">
        <strong class="info-text">
          Nome:
          <em>{{ aluno.nome }}</em>
        </strong>

        <strong class="info-text">
          Identidade:
          <em>{{ aluno.identidade }}</em>
        </strong>

        <strong class="info-text">
          Nascimento:
          <em>{{ aluno.nascimento }}</em>
        </strong>
      </v-card-text>
    </v-card>
    <br />
    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">Histórico</v-card-title>
      <v-card-text class="app-card-content">
        <v-expansion-panels accordion flat hover>
          <v-expansion-panel v-for="(escola, index) in escolas" :key="index">
            <v-expansion-panel-header>
              <span>
                <v-icon color="#212121" size="16" style="margin-top:-6px;"
                  >account_balance</v-icon
                >
                {{ escola.nome }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-expansion-panels accordion flat>
                <v-expansion-panel
                  v-for="(curso, idx) in escola.cursos"
                  :key="idx"
                >
                  <v-expansion-panel-header>
                    <span>
                      <v-icon color="#212121" size="16" style="margin-top:-6px;"
                        >collections_bookmark</v-icon
                      >
                      {{ curso.nome }}
                    </span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Situação</th>
                            <th class="text-left">Data</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(tramitacao, i) in curso.tramitacoes"
                            :key="i"
                          >
                            <td>{{ tramitacao.nome }}</td>
                            <td>{{ tramitacao.data }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as _ from "lodash";

export default {
  //name: ResultadoCarteiraMacroRegicao,
  props: {
    carteiras: Array
  },
  data() {
    return {
      aluno: null,
      escolas: []
    };
  },
  methods: {
    loadAluno() {
      const { nome, identidade, dataNascimento } = this.carteiras[0];
      this.aluno = {
        nome: nome,
        identidade: identidade,
        nascimento: dataNascimento
      };
      this.loadEscolas();
    },
    loadEscolas() {
      // TODO: ver futuramente como fazer esses melhor esses filtros
      // Filtra as Escolas
      this.carteiras.map((carteira, index) => {
        const hasEscola = _.find(this.escolas, [
          "codigo",
          carteira.codigoEscola
        ]);

        if (!hasEscola) {
          this.escolas.push({
            codigo: carteira.codigoEscola,
            nome: carteira.nomeEscola,
            cursos: []
          });
        }
      });

      // Filtra os Cursos
      this.escolas.map((escola, index) => {
        this.carteiras.map((carteira, idx) => {
          const hasCurso = _.find(this.escolas[index].cursos, [
            "codigo",
            carteira.codigo_curso
          ]);
          if (!hasCurso && escola.codigo === carteira.codigoEscola) {
            this.escolas[index].cursos.push({
              codigo: carteira.codigo_curso,
              nome: carteira.nomeCurso,
              tramitacoes: []
            });
          }
        });
      });

      // Filtra as Tramitações
      this.escolas.map((escola, index) => {
        escola.cursos.map((curso, idx) => {
          this.carteiras.map(carteira => {
            const hasTramitacao = _.find(
              this.escolas[index].cursos[idx].tramitacoes,
              ["codigo", carteira.codigoPedido]
            );

            if (!hasTramitacao && carteira.codigo_curso === curso.codigo) {
              this.escolas[index].cursos[idx].tramitacoes.push({
                codigo: carteira.codigoPedido,
                nome: carteira.situacaoPedido,
                data: carteira.dataPedido
              });
            }
          });
        });
      });
    }
  },
  mounted() {
    this.loadAluno();
  }
};
</script>

<style></style>
